module.exports = __webpack_public_path__ + "static/media/0026.67a1a933.svg";